module.exports = __webpack_public_path__ + "img/copied.83a4b391.svg";